export function cleanSessionName(name) {
  if (!name) return name;
  // Remove trailing " #number" (e.g., "Visit 2026-07-01 #3" -> "Visit 2026-07-01")
  return name.replace(/\s*#\d+$/, '');
}